import type { Ref } from 'vue'

import { storeToRefs } from 'pinia'
import { onBeforeMount } from 'vue'

import { useCsrfStore } from '@app/shared/pinia/csrf'

export default function useCsrfToken(): Ref<string> {
  const tokenStore = useCsrfStore()

  const { token } = storeToRefs(tokenStore)

  onBeforeMount(() => {
    if (token.value === '') {
      const csrfToken = document
        .querySelector<HTMLMetaElement>('meta[name="csrf-token"]')
        ?.getAttribute('content')

      if (csrfToken) {
        tokenStore.receiveToken(csrfToken)
      }
    }
  })

  return token
}
